import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'
import { Player } from '@mos/api/player/dto-client'
import { isServer } from '@mos/client/shared/utils'
import { catchError, map, of } from 'rxjs'
import { AuthRepository } from '../auth.repository'
import { AuthService } from '../auth.service'

export const canActivateAuth: CanActivateFn = () => {
	if (isServer) {
		return of(false)
	}
	const authRepository = inject(AuthRepository)
	const authService = inject(AuthService)

	const authState = authRepository.state
	if (authState.player) {
		return of(true)
	}

	if (!authState.token) {
		return of(false)
	}

	return authService.getPlayer().pipe(
		map((player: Player) => {
			authRepository.setPlayer(player)
			return true
		}),
		catchError(() => {
			return authService.logout()
		}),
	)
}
